module.exports = __webpack_public_path__ + "img/card_brindisi_background.b0a92454.png";